import { render } from "./FontEditor.vue?vue&type=template&id=cd3f0c48&scoped=true"
import script from "./FontEditor.vue?vue&type=script&lang=ts"
export * from "./FontEditor.vue?vue&type=script&lang=ts"

import "./FontEditor.vue?vue&type=style&index=0&id=cd3f0c48&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cd3f0c48"

export default script